<template>
  <div class="content">
    <el-dialog v-bind="$attrs" v-on="$listeners" @open="onOpen" title="新增">
      <el-row :gutter="15">
        <el-form
          ref="addRef"
          :model="dictInfo"
          :rules="rules"
          size="medium"
          label-width="100px"
        >
          <el-col :span="8">
            <el-form-item label="名称" prop="name">
              <el-input
                v-model="dictInfo.name"
                clearable
                :style="{ width: '100%' }"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="编号" prop="code">
              <el-input
                v-model="dictInfo.code"
                clearable
                :style="{ width: '100%' }"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="描述" prop="description">
              <el-input
                v-model="dictInfo.description"
                clearable
                :style="{ width: '100%' }"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="父ID" prop="parentId">
              <el-select
                v-model="dictInfo.parentId"
                placeholder="请选择父id"
                @change="handleChange"
              >
                <el-option
                  v-for="element in parentIdList"
                  :key="element.id"
                  :label="element.name"
                  :value="element.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="状态" prop="status">
              <el-select
                v-model="dictInfo.status"
                placeholder="请选择状态"
                @change="handleChange"
              >
                <el-option
                  v-for="element in statusList"
                  :key="element.id"
                  :label="element.type"
                  :value="element.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="类型" prop="type">
              <el-input
                v-model="dictInfo.type"
                clearable
                :style="{ width: '100%' }"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-form>
      </el-row>
      <div slot="footer" v-if="true">
        <el-button @click="close">取消</el-button>
        <el-button type="primary" @click="handelConfirm">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {addDict,findAllForSelect}  from '@/api/systemData'
export default {
  props: [""],
  data() {
    return {
      dictInfo: {
        id:"",  
        name:"",  //名称
        code: "",  //编号
        description: "",  //描述
        parentId: "",  //父ID
        status: "",  //状态 0禁用，1启用
        type: "",  //类型
        createUser: "",  //创建人
        createDate: "",  //创建时间
        updateUser: "",  //修改人
        updateDate: "",  //修改日期
      },
      statusList:[
        { id: 1, type: "启用" },
        { id: 0, type: "禁用" },
      ],
      parentIdList:[],
      rules: {
        name: [
          {
            required: true,
            message: "名称不能为空",
            trigger: "blur",
          },
        ],
        code: [
          {
            required: true,
            message: "编号不能为空",
            trigger: "blur",
          },
        ],
        description: [
          {
            required: false,
            message: "描述不能为空",
            trigger: "blur",
          },
        ],
        parentId: [
          {
            required: false,
            message: "父ID不能为空",
            trigger: "blur",
          },
        ],
        status: [
          {
            required: false,
            message: "状态不能为空",
            trigger: "blur",
          },
        ],
        type: [
          {
            required: true,
            message: "类型不能为空",
            trigger: "blur",
          },
        ],
      },
    };
  },
  computed: {},
  watch: {},
  created() {
    this.findAllForSelect();
  },
  mounted() {},
  methods: {
    findAllForSelect(){
      findAllForSelect({}).then((res)=>{
        if(res.code = 10000){
          this.parentIdList = res.data;
        }
      })
    },
    handleChange(value){
      console.log("handleChange-value",value);
    },
    onOpen() {},
    onClose() {
      this.$refs["addRef"].resetFields();
    },
    close() {
      this.$emit("update:visible", false);
    },
    handelConfirm() {
      this.$refs["addRef"].validate((valid) => {
        if (valid) {
          addDict(this.dictInfo).then((res) => {
            if (res.code == 10000) {
              this.$emit("add-success");
            }
          });
          this.close();
        }
      });
    },
  },
};
</script>
<style>
.content {
  background-color: #fff;
  padding: 10px;
  
}
</style>
